<footer>
    <div class="footer-powered">
        <span>Powered By</span>
        <div class="logo-container">
            <img src="assets/icons/cue-logo-blue.png" alt="CUE">
        </div>
    </div>
    <div class="footer-copyright">
        <div class="copyright">{{'@'}} {{currentYear}} All Rights Reserved</div>
    </div>
</footer>
